import React from 'react';
import type { PickStatus, SessionStatus } from '../../api/shopping';

interface PickBadgeProps {
  status: PickStatus;
}

const pickLabels: Record<PickStatus, string> = {
  TO_PICK: 'A pegar',
  PICKED: 'Pego',
  SKIPPED: 'Pulado',
  NOT_FOUND: 'Não encontrado',
};

const pickClasses: Record<PickStatus, string> = {
  TO_PICK: 'bg-emerald-100 text-emerald-700',
  PICKED: 'bg-green-500 text-white',
  SKIPPED: 'bg-gray-200 text-gray-600',
  NOT_FOUND: 'bg-red-100 text-red-600',
};

export function PickBadge({ status }: PickBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${pickClasses[status]}`}
    >
      {pickLabels[status]}
    </span>
  );
}

interface SessionBadgeProps {
  status: SessionStatus;
}

const sessionLabels: Record<SessionStatus, string> = {
  IN_PROGRESS: 'Em andamento',
  FINISHED: 'Finalizada',
  CANCELLED: 'Cancelada',
};

const sessionClasses: Record<SessionStatus, string> = {
  IN_PROGRESS: 'bg-emerald-100 text-emerald-700',
  FINISHED: 'bg-blue-100 text-blue-700',
  CANCELLED: 'bg-gray-200 text-gray-600',
};

export function SessionBadge({ status }: SessionBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${sessionClasses[status]}`}
    >
      {sessionLabels[status]}
    </span>
  );
}

interface GenericBadgeProps {
  children: React.ReactNode;
  variant?: 'emerald' | 'gray' | 'red' | 'amber' | 'blue';
  className?: string;
}

const genericClasses: Record<NonNullable<GenericBadgeProps['variant']>, string> = {
  emerald: 'bg-emerald-100 text-emerald-700',
  gray: 'bg-gray-100 text-gray-600',
  red: 'bg-red-100 text-red-600',
  amber: 'bg-amber-100 text-amber-700',
  blue: 'bg-blue-100 text-blue-700',
};

export function Badge({ children, variant = 'gray', className = '' }: GenericBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${genericClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
